// extracted by mini-css-extract-plugin
export default {"whyDiv":"Why_whyDiv__1Abjp","contentDiv":"Why_contentDiv__yTSfa"};